const isText = RegExp(/^[A-Z ]+$/i)
const isEmail = RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
const isPhone = RegExp(/^(0[\d]{9})$/)
const isNumber = RegExp(/^\d+$/)

export default function formValidation(name, value, schema) {
  const { validate, minLength, maxLength } = schema[name]
  let error = ""

  if (minLength && value.length < minLength) error = `Campul trebuie sa contina minim ${minLength} caractere.`
  else if (maxLength && value.length > maxLength) error = `Campul trebuie sa contina maxim ${maxLength} caractere!`
  if (!validate) return

  switch (validate) {
    case "text":
      if (!isText.test(value)) error = "Campul trebuie sa contina doar litere."
      break

    case "number":
      if (!isNumber.test(value)) error = "Campul trebuie sa contina doar numere."
      break

    case "email":
      if (!isEmail.test(value)) error = "Introduceti o adresa de email valida."
      break

    case "phone":
      const newValue = value.replace(/[-\./\s+]/g,'');
      if (!isPhone.test(newValue)) error = "Introduceti un numar de telefon valid."
      break

    default:
      break
  }

  return error
}